module.exports = __webpack_public_path__ + "media/img/wilsonkjc14-fa2ece85.jpg";